function Footer() {
    return(
        <div>
            
            <div className='site-footer hidden-xs hidden-sm'>
                <div className='footer-column'>
                    <h4>Martin Mechanical<br/><br/>
                    Licensed and Insured. | &copy; 2026
                    </h4>
                </div>
                <div className='footer-column'>
                    <h4>Call Now: <span style={{textDecoration:"underline"}}>(202) 257-2173</span></h4>
                    <h4>Email: <span style={{textDecoration:"underline"}}>MartinmechanicalLLC@yahoo.com</span></h4>
                    {/* <h4>Follow Us: <a className='footer-link' href="https://facebook.com">Facebook</a> | <a className='footer-link' href="https://instagram.com">Instagram</a></h4> */}
                </div>
            </div>

            <div className='site-footer visible-xs visible-sm'>
                <h4>Martin Mechanical</h4>
                Licensed and Insured. | &copy; 2026
                <h5>Call Now: <span style={{textDecoration:"underline"}}>(202) 257-2173</span></h5>
                <h5>Email: <span style={{textDecoration:"underline"}}>MartinmechanicalLLC@yahoo.com</span></h5>
                {/* <h5>Follow Us: <a className='footer-link' href="https://facebook.com">Facebook</a> | <a className='footer-link' href="https://instagram.com">Instagram</a></h5> */}
            </div>
        </div>
    )
}

export default Footer;
